import styled from 'styled-components/macro'

// Shows the venue logo as a round setting icon, in place of a sticker icon (the sticker fallback stays as is)
export const RoundIconWrapper = styled.div`
  .setting-icon img.logo {
    border-radius: 100%;
    transform: scale(1.2);
  }
`
